import { Component, OnInit } from '@angular/core';
import { PrimeNG } from 'primeng/config';
import { AppConfig, LayoutService } from './layout/service/app.layout.service';
import { ApiService } from './services/api/api.service';
import { initializeApp } from 'firebase/app';
import { environment } from 'src/environments/environment';
import { getAuth, onAuthStateChanged } from '@firebase/auth';

@Component({
    standalone: false,
    selector: 'app-root',
    templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {

    constructor(private primengConfig: PrimeNG, private layoutService: LayoutService, private apiService: ApiService) {
        this.apiService.currentUserChange.subscribe((user) => {
            if (user.is_superadmin) {
                this.apiService.getUsers().subscribe((data) => { });
                this.apiService.getWaitingUsers().subscribe((data) => { });
                this.apiService.getCompanies().subscribe((data) => { });
                this.apiService.getOrganisations().subscribe((data) => { });
            }
        });

        initializeApp(environment.firebaseConfig);
    }

    ngOnInit(): void {
        // this.primengConfig.ripple = true;       //enables core ripple functionality

        // change the calendar locale to french based on the following configuration

        const en = {
            "startsWith": "Starts with",
            "contains": "Contains",
            "notContains": "Not contains",
            "endsWith": "Ends with",
            "equals": "Equals",
            "notEquals": "Not equals",
            "noFilter": "No Filter",
            "lt": "Less than",
            "lte": "Less than or equal to",
            "gt": "Greater than",
            "gte": "Greater than or equal to",
            "is": "Is",
            "isNot": "Is not",
            "before": "Before",
            "after": "After",
            "dateIs": "Date is",
            "dateIsNot": "Date is not",
            "dateBefore": "Date is before",
            "dateAfter": "Date is after",
            "clear": "Clear",
            "apply": "Apply",
            "matchAll": "Match All",
            "matchAny": "Match Any",
            "addRule": "Add Rule",
            "removeRule": "Remove Rule",
            "accept": "Yes",
            "reject": "No",
            "choose": "Choose",
            "upload": "Upload",
            "cancel": "Cancel",
            "dayNames": ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            "dayNamesShort": ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
            "dayNamesMin": ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
            "monthNames": ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            "monthNamesShort": ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
            "dateFormat": "mm/dd/yy",
            "firstDayOfWeek": 0,
            "today": "Today",
            "weekHeader": "Wk",
            "weak": "Weak",
            "medium": "Medium",
            "strong": "Strong",
            "passwordPrompt": "Enter a password",
            "emptyMessage": "No results found",
            "emptyFilterMessage": "No results found"
        };

        const fr = {
            "startsWith": "Commence par",
            "contains": "Contient",
            "notContains": "Ne contient pas",
            "endsWith": "Se termine par",
            "equals": "Égal",
            "notEquals": "Pas égal",
            "noFilter": "Pas de filtre",
            "lt": "Moins que",
            "lte": "Moins que ou égal à",
            "gt": "Plus que",
            "gte": "Plus grand ou égal à",
            "is": "Est",
            "isNot": "N'est pas",
            "before": "Avant",
            "after": "Après",
            "dateIs": "La date est",
            "dateIsNot": "La date n'est pas",
            "dateBefore": "La date est avant",
            "dateAfter": "La date est après",
            "clear": "Effacer",
            "apply": "Appliquer",
            "matchAll": "Correspondre à tous",
            "matchAny": "Correspondre à n'importe quel",
            "addRule": "Ajouter une règle",
            "removeRule": "Supprimer la règle",
            "accept": "Oui",
            "reject": "Non",
            "choose": "Choisir",
            "upload": "Télécharger",
            "cancel": "Annuler",
            "dayNames": ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
            "dayNamesShort": ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
            "dayNamesMin": ["D", "L", "M", "M", "J", "V", "S"],
            "monthNames": ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
            "monthNamesShort": ["Jan", "Fév", "Mar", "Avr", "Mai", "Jun", "Jul", "Aoû", "Sep", "Oct", "Nov", "Déc"],
            "dateFormat": "dd/mm/yy",
            "firstDayOfWeek": 1,
            "today": "Aujourd'hui",
            "weekHeader": "Sem",
            "weak": "Faible",
            "medium": "Moyen",
            "strong": "Fort",
            "passwordPrompt": "Entrez un mot de passe",
            "emptyMessage": "Aucun résultat trouvé",
            "emptyFilterMessage": "Aucun résultat trouvé"
        };

        this.primengConfig.setTranslation(fr);

        let theme = localStorage.getItem('theme');
        const element = document.querySelector('html');
        let colorScheme = 'dark';

        if (!theme) {
            localStorage.setItem('theme', 'lara-dark-indigo');
            theme = 'lara-dark-indigo';
            element?.classList.add('my-app-dark');
        }

        if (theme === 'lara-light-indigo') {
            theme = 'lara-light-indigo';
            element.classList.remove('my-app-dark');
            colorScheme = 'light';
        } else {
            theme = 'lara-dark-indigo';
            element.classList.add('my-app-dark');
            colorScheme = 'dark';
        }

        //optional configuration with the default configuration
        const config: AppConfig = {
            ripple: false,                      //toggles ripple on and off
            inputStyle: 'outlined',             //default style for input elements
            menuMode: 'static',                 //layout mode of the menu, valid values are "static" and "overlay"
            colorScheme: colorScheme,               //color scheme of the template, valid values are "light" and "dark"
            theme: theme,         //default component theme for PrimeNG
            scale: 14                           //size of the body font size to scale the whole application
        };
        this.layoutService.config.set(config);
        // change the surface color of the app using layout service


    }
}


